import Vue from 'vue';
import Router from 'vue-router';
import DataMaintenance from './data-maintenance';
import EarlyWarning from './early-warning';
import SystemManagement from './system-management';
import FloodForecast from './flood-forecast';

Vue.use(Router)

// 避免路由重复冗余
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => { return err })
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/wcp/login'
    },
    {
      path: '/wcp/login',
      name: 'Login',
      meta: { title: '\u767b\u5f55' },
      component: () => import('@/views/login/index.vue')
    },
    {
      path: '/',
      name: "MonitorMapLayout",
      component: () => import('@/views/layout/LayoutA.vue'),
      children: [
        {
          path: "/wcp/monitor/a/map",
          name: "MonitorMap",
          meta: { title: '\u76d1\u63a7\u4e00\u5f20\u56fe', requireAuth: true },
          components: {
            left: () => import("@/views/monitor-map/LeftSide"),
            right: () => import("@/views/monitor-map/RightSide"),
            map: () => import("@/views/monitor-map/MonitorMap"),
            footer: () => import("@/views/monitor-map/Footer"),
          }
        }
      ]
    },
    {
      path: '/',
      name: "DamSafetyLayout",
      component: () => import('@/views/layout/LayoutC'),
      children: [
        {
          path: "/wcp/dam/safety",
          name: "DamSafety",
          meta: { title: '\u5927\u575d\u5b89\u5168', requireAuth: true },
          components: {
            left: () => import("@/views/dam-safety/reservoir-list/ReservoirList"),
            main: () => import("@/views/dam-safety/index")
          }
        }
      ]
    },
    {
      path: '/',
      name: "FloodRainfallLayout",
      component: () => import('@/views/layout/LayoutB'),
      children: [
        {
          path: "/wcp/flood/rainfall",
          name: "FloodRainfall",
          meta: { title: '\u6c34\u96e8\u60c5', requireAuth: true },
          components: {
            main: () => import("@/views/flood-rainfall/index")
          }
        }
      ]
    },
    {
      path: '/',
      name: "DataMaintenanceLayout",
      component: () => import('@/views/layout/LayoutC'),
      children: DataMaintenance
    },
    {
      path: '/',
      name: "VideoMonitorLayout",
      component: () => import('@/views/layout/LayoutC'),
      children: [
        {
          path: "/wcp/video/monitor",
          name: "VideoMonitor",
          meta: { title: '\u89c6\u9891\u56fe\u50cf', requireAuth: true },
          components: {
            left: () => import("../views/video-monitor/VideoList.vue"),
            main: () => import("../views/video-monitor/VideoWall.vue")
          }
        }
      ]
    },
    {
      path: '/',
      name: "EarlyWarningLayout",
      component: () => import('@/views/layout/LayoutC'),
      children: EarlyWarning
    },
    {
      path: '/',
      name: "FloodForecastLayout",
      component: () => import('@/views/layout/LayoutC'),
      children: FloodForecast
    },
    {
      path: '/',
      name: "SystemManagementLayout",
      component: () => import('@/views/layout/LayoutC'),
      children: SystemManagement
    },
    {
      path: "/wcp/data/maintenance/data/report/report-page",
      name: "ReportPage",
      meta: { title: '\u6570\u636e\u62a5\u8868', requireAuth: true },
      component: () => import("@/views/data-maintenance/data-report/report/ReportPage"),
    },
    {
      path: "/wcp/file-preview",
      name: "FilePreview",
      meta: { title: '\u6587\u4ef6\u9884\u89c8', requireAuth: true },
      component: () => import("@/components/file-preview/FilePreview"),
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/components/404/404'),
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js